import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=631c52f0&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=js&"
export * from "./deal.vue?vue&type=script&lang=js&"
import style0 from "./deal.vue?vue&type=style&index=0&id=631c52f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631c52f0",
  null
  
)

export default component.exports